import React, { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { updateStaff } from "../../services/staff";
import {
  Box,
  Button,
  Center,
  Flex,
  Grid,
  Image,
  Text,
  Title,
} from "@mantine/core";
import useStyles from "./style";
import TableLoader from "../../components/TableLoader";

export const OrganizationInvite = () => {
  const { token , orgName} = useParams();
  const { classes } = useStyles();
  const [loading, setLoading] = useState(false);
  const [updated, setUpdated] = useState(false);

  const handleUpdate = async () => {
    setLoading(true);
    const result = await updateStaff({ token }); // call API with staff ID
    if (result) setUpdated(true);
    setLoading(false);
  };

  //  useEffect(() => {
  //   setLoading(true);
  //   const update = async () => {
  //     const result = await updateStaff({ token }); // pass as {id}
  //     if (result) setUpdated(true);
  //     setLoading(false);
  //   };
  //   update();
  // }, [token]);

  return (
    <Grid className={classes.container}>
      <Grid.Col span={6} className={classes.left_pane}>
        <Box className={classes.welcome}>
          <Link to={"/"}>
            <Image
              src="/assets/images/logo.png"
              mr={"auto"}
              fit="fill"
              className={classes.logo}
            />
          </Link>
        </Box>
      </Grid.Col>
      <Grid.Col
        span={6}
        className={classes.right_pane}
        style={{ position: "relative" }}
      >
        <Box
          style={{
            background: "white",
            height: "50%",
            borderRadius: "10px",
            width: "100%",
            position: "absolute",
            top: "30%",
            left: "-50%",
            border: "1px solid gray",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Center>
            {loading ? (
              <>
                <Text ff={"Inter"} fz={20} fw={700}>
                  Updating...
                </Text>
                <TableLoader />
              </>
            ) : updated ? (
              <Flex
                align={"center"}
                direction={"column"}
                justify={"center"}
                gap={20}
              >
                <Title order={1}>Invite Accepted Successfully!</Title>
                <Button
                  size="xl"
                  color="yellow"
                  radius={"md"}
                  variant="filled"
                  onClick={() => (window.location.href = "/login")}
                >
                  Go to Login
                </Button>
              </Flex>
            ) : (
              <Flex
                align={"center"}
                direction={"column"}
                justify={"center"}
                gap={20}
              >
                <Title order={1}>Welcome to {orgName}</Title>
                <Button
                  size="xl"
                  color="yellow"
                  radius={"md"}
                  variant="filled"
                  onClick={handleUpdate}
                >
                  Confirm to Join
                </Button>
              </Flex>
            )}
          </Center>
        </Box>
      </Grid.Col>
    </Grid>
  );
};
